import { GetStaticPaths } from "next";
import { NextSeo } from "next-seo";
import { JobListing } from "../../../common/types";
import Header from "../../../view/components/Header/Header";
import Kompanija from "../../../view/screens/Kompanija/Kompanija";
import {
    CompaniesSingleResponse,
    getAllCompaniesForBuild,
    handleGetSingleCompany,
} from "../../api/company";
import { handleGetIntervjui, returnIntervjui } from "../../api/intervju/get";
import { getAllJobsPerCompany } from "../../api/job/get";
import { handleGetUtisci, returnUtisci } from "../../api/utisak/get";

type KompanijaProps = {
    company: CompaniesSingleResponse;
    companyJobs: JobListing[];
    utisci: returnUtisci[];
    intervjui: returnIntervjui[];
};

export default function KompanijaPage({
    company,
    companyJobs,
    utisci,
}: KompanijaProps) {
    return (
        <div className="relative bg-white">
            <Header />
            <NextSeo
                title={`${company.name} | Poslovi i iskustva`}
                description={`Otvorene pozicije, iskustva o radu i iskustva sa intervjua za kompaniju ${company.name}.`}
                canonical={`https://www.dzobs.com/kompanija/${company.slug}`}
                openGraph={{
                    images: [
                        {
                            url: company.logo,
                        },
                    ],
                }}
            />
            <Kompanija
                data={company}
                companyJobs={companyJobs}
                utisci={utisci}
                type="o-kompaniji"
            />
        </div>
    );
}

export const getStaticPaths: GetStaticPaths = async () => {
    const companies = await getAllCompaniesForBuild();

    const paths = companies?.map((comp) => ({
        params: { slug: comp.slug },
    }));

    return {
        paths,
        fallback: "blocking",
    };
};

export async function getStaticProps({
    params,
}: {
    params: {
        slug: string;
    };
}) {
    const { slug } = params;

    const company = await handleGetSingleCompany(slug);

    if (!company?.id) {
        return {
            revalidate: 60,
            notFound: true,
        };
    }

    const companyJobs = await getAllJobsPerCompany(slug);
    const utisci = await handleGetUtisci(company.id);
    const intervjui = await handleGetIntervjui(company.id);

    return {
        props: { company, companyJobs, utisci, intervjui },
        revalidate: 60,
    };
}
